import client from "./client";

/** TAS-295 — builder (Customer) contact management. Direct-api-import path, no manager/dataLayer. */

export interface CustomerWithContactCount {
    customerID: number;
    altCustomerID: string | null;
    name: string | null;
    contactCount: number;
}

export interface CustomerContact {
    customerContactID: number;
    customerID: number;
    name: string;
    roleTitle: string | null;
    email: string | null;
    phoneNumber: string | null;
    receivesWorkOrderEmails: boolean;
    active: boolean;
    createdAt: string;
    updatedAt: string | null;
}

export interface CustomerContactSaveRequest {
    name: string;
    roleTitle?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    receivesWorkOrderEmails?: boolean;
}

export async function getCustomersWithContacts(): Promise<CustomerWithContactCount[]> {
    const response = await client.get<CustomerWithContactCount[]>("admin/customers");
    return response.data;
}

export async function getCustomerContacts(customerID: number): Promise<CustomerContact[]> {
    const response = await client.get<CustomerContact[]>(`admin/customers/${customerID}/contacts`);
    return response.data;
}

export async function createCustomerContact(customerID: number, body: CustomerContactSaveRequest): Promise<void> {
    await client.post(`admin/customers/${customerID}/contacts`, body);
}

export async function updateCustomerContact(customerContactID: number, body: CustomerContactSaveRequest): Promise<void> {
    await client.put(`admin/customers/contacts/${customerContactID}`, body);
}

export async function deleteCustomerContact(customerContactID: number): Promise<void> {
    await client.delete(`admin/customers/contacts/${customerContactID}`);
}

// ===== TAS-296 — job-level contacts =====

export interface CustomerProject {
    projectID: number;
    altProjectID: string | null;
    name: string | null;
    active: boolean;
}

export interface ProjectContact {
    projectContactID: number;
    projectID: number;
    sourceCustomerContactID: number | null;
    name: string;
    roleTitle: string | null;
    email: string | null;
    phoneNumber: string | null;
    receivesWorkOrderEmails: boolean;
    active: boolean;
    createdAt: string;
    updatedAt: string | null;
}

export async function getCustomerProjects(customerID: number): Promise<CustomerProject[]> {
    const response = await client.get<CustomerProject[]>(`admin/customers/${customerID}/projects`);
    return response.data;
}

/** First read seeds the job's contacts from the builder; `seeded` reports when that happened. */
export async function getProjectContacts(projectID: number): Promise<{ contacts: ProjectContact[]; seeded: boolean }> {
    const response = await client.get<{ contacts: ProjectContact[]; seeded: boolean }>(
        `admin/customers/projects/${projectID}/contacts`
    );
    return response.data;
}

export async function createProjectContact(projectID: number, body: CustomerContactSaveRequest): Promise<void> {
    await client.post(`admin/customers/projects/${projectID}/contacts`, body);
}

export async function updateProjectContact(projectContactID: number, body: CustomerContactSaveRequest): Promise<void> {
    await client.put(`admin/customers/projects/contacts/${projectContactID}`, body);
}

export async function deleteProjectContact(projectContactID: number): Promise<void> {
    await client.delete(`admin/customers/projects/contacts/${projectContactID}`);
}
